import { Divider, Empty, PageHeader, Table } from 'antd';
import Filters from 'components/filters';
import UIHelper from 'helpers/UIHelper';
import styles from '../../candidates/main/style.module.scss';
import { useCustomerLogs } from '../useCustomerLogs';
import { useTranslation } from 'react-i18next';

const MainPage = () => {
  const { t } = useTranslation();
  const { filters, columns, data, onChangeTableFilter, loading } =
    useCustomerLogs(true);
  return (
    <>
      <PageHeader title={t('Log GDPR').toUpperCase()} />
      <div className={styles.container}>
        <Filters filters={filters} />
        <Divider />
        <Table
          locale={{
            emptyText: <Empty />,
          }}
          columns={UIHelper.assignTire(columns)}
          dataSource={data.customer_logs}
          pagination={data.pagination}
          onChange={onChangeTableFilter}
          loading={loading}
          scroll={{ x: 1500 }}
        />
      </div>
    </>
  );
};

export default MainPage;
